import { useTranslation } from "react-i18next"
import { iReadingQuestion } from "../../shared/src/types/Interaction"

import { isAfterDeadline } from "./ReadingQuestion"
import { Box } from "@mui/material"
import dayjs from "dayjs"


  const Deadline = ({readingQuestion}: {readingQuestion: iReadingQuestion}) => {
    const { t } = useTranslation()
    if(readingQuestion.openUntil && !isAfterDeadline(readingQuestion)) {
      return (
        <Box sx={{
          fontSize: "13px",
          fontWeight: 300
        }}>
          {t('still open for {{remaing}}', {remaing: dayjs().to(readingQuestion.openUntil *1000, true)})}
        </Box>
      )
    }
    return null
  }

  export default Deadline